import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircle, Activity, Droplets } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-28 bg-sage-500 text-white relative overflow-hidden" data-id="element-325">
      {/* Subtle background pattern/texture could go here, using a simple radial gradient for now */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.1)_0%,transparent_100%)]" data-id="element-326"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-327">
        <FadeIn data-id="element-328">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-12 text-center" data-id="element-329">
            El problema no es lo que comes,
            <br data-id="element-330" />
            es cómo reacciona tu biología.
          </h2>
        </FadeIn>

        <div className="space-y-8 md:space-y-12" data-id="element-331">
          <FadeIn delay={0.1} data-id="element-332">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-333">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white/20 flex items-center justify-center" data-id="element-334">
                <AlertCircle className="w-6 h-6 text-white" data-id="element-335" />
              </div>
              <div data-id="element-336">
                <h3 className="text-xl font-bold mb-3 font-sans" data-id="element-337">
                  El estado de "Alerta Constante"
                </h3>
                <p className="text-sage-100 leading-relaxed text-lg" data-id="element-338">
                  La mayoría de las mujeres viven en un estado de alerta
                  constante. El estrés, la falta de sueño y los alimentos que la
                  industria nos vende como "saludables" mantienen tu cortisol
                  por las nubes.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-339">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-340">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white/20 flex items-center justify-center" data-id="element-341">
                <Activity className="w-6 h-6 text-white" data-id="element-342" />
              </div>
              <div data-id="element-343">
                <h3 className="text-xl font-bold mb-3 font-sans" data-id="element-344">
                  El Efecto Dominó
                </h3>
                <p className="text-sage-100 leading-relaxed text-lg" data-id="element-345">
                  Esto crea un efecto dominó: tu intestino se vuelve permeable,
                  tu metabolismo se ralentiza y tu cuerpo decide retener cada
                  gramo de agua para "protegerse" de un ataque que no cesa. Por
                  eso te sientes "inflada" como un globo al final del día.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-346">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-347">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white/20 flex items-center justify-center" data-id="element-348">
                <Droplets className="w-6 h-6 text-white" data-id="element-349" />
              </div>
              <div data-id="element-350">
                <h3 className="text-xl font-bold mb-3 font-sans" data-id="element-351">
                  La Verdadera Causa
                </h3>
                <p className="text-sage-100 leading-relaxed text-lg" data-id="element-352">
                  Si te despiertas cansada, tienes neblina mental y tu vientre
                  parece tener vida propia después de comer, el problema no es
                  falta de voluntad. Es una inflamación celular profunda.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}